<button type="button" id="btnIssueApprove" (click)="approveConfirm()" style="display:none">ApproveConfirm</button>
<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="col-sm-12" style="top:-10px;">

          <ul class="nav nav-tabs nav-tabs-custom" id="TabulIssueList">
            <li class="nav-item">
              <a data-toggle="tab" href="#WIPList" class="nav-link active" name="WIP" (click)="GetDataByActiveTab('WIP')">WIP</a>
            </li>
            <li class="nav-item">
              <a data-toggle="tab" href="#PublishedList" class="nav-link" name="Published" (click)="GetDataByActiveTab('Published')">Published</a>
            </li>
            <li class="nav-item">
              <a data-toggle="tab" href="#BacklogIssueList" class="nav-link" name="BacklogIssue" (click)="GetDataByActiveTab('BacklogIssue')"
                 *ngIf="checkIssueBackLogTab">Backlog Issue</a>
            </li>
          </ul>
          <button type="button" id="btnGetVolumeIssues" (click)="getVolumeIssue()" style="display:none">GetVolumeIssue</button>
          <div class="row">
            <div class="col-12" id="divIssueList" style="padding-top:10px;">
              <div class="row" id="divFilterList">
                <div class="col-sm-6">
                  <label>Journal(s)</label>
                  <select id="lstJournals" class="form-control select2" multiple onchange="$('#btnGetVolumeIssues').trigger('click');">
                    <option *ngFor="let item of modelItem.JournalList" value={{item.ID}}>
                      {{item.Acronym}}
                    </option>
                  </select>
                </div>
                <div class="col-sm-6">
                  <label>Status</label>
                  <select id="ddlStatus" class="form-control select2" multiple>
                    <option *ngFor="let item of lStatusList" value={{item.Activity}} [selected]="item.Activity==filterStatus">
                      {{item.Activity}}
                    </option>
                  </select>
                </div>
                <div class="col-sm-2">
                  <label>Volume</label>
                  <select id="lstVolume" class="form-control select2">
                    <option selected value="0">All</option>
                    <option *ngFor="let item of modelItem.volumeList" value={{item.ID}}>
                      {{item.Volume}}
                    </option>
                  </select>
                </div>
                <div class="col-sm-2">
                  <label>Issue</label>
                  <select id="lstIssue" class="form-control select2">
                    <option selected value="0">All</option>
                    <option *ngFor="let item of modelItem.issueList" value={{item.ID}}>
                      {{item.Issue}}
                    </option>
                  </select>
                </div>
                <div class="col-2" style="display:none">
                  <label>Year</label>
                  <select id="ddlYearList" class="form-control select2">
                    <option [value]="0" selected="selected">Select</option>
                    <option *ngFor="let item of modelItem.YearList" value={{item.Year}}>
                      {{item.Year}}
                    </option>
                  </select>
                </div>
                <!--<div class="col-2" style="display:none">
                <label>Status</label>
                <select id="ddlStatus" class="form-control select2">
                  <option value="All">All</option>-->
                <!--<option value="Yettostart">Yet to Start</option>-->
                <!--<option value="Inprocess" selected="selected">In Progress</option>
                    <option value="Completed">Completed</option>
                  </select>
                </div>-->
                <div class="col-sm" id="ULTabul">
                  <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" title="Get" id="btnLoadList" (click)="LoadIssueDataList('List')">Search</button>
                  <button type="button" class="btn btn-outline-danger waves-effect waves-light clsMargin" title="Clear" (click)="ResetDataListFilter()" style="margin-left:10px">Reset</button>
                </div>
              </div>

              <div id="divDataList">
                <button type="button" id="btnPopupDT" (click)="LoadVolIssueData()" style="display:none">Info</button><br />
                <button type="button" id="btnEditIssue" (click)="LoadVolIssueData()" style="display:none">Info</button><br />
                <button type="button" id="btnModify" (click)="ShowIssueAdd()" style="display:none">Info</button>
                <table #dataTableList class="display" style="width:100%"></table>
              </div>

              <div id="divVolIssBtn" style="display:none">
                <span *ngFor="let item of modelItem.VolumeIssueList" class="btn btn-outline-info waves-effect waves-light col-2 VOLISS {{item.CssValue}}" id="btnVI{{item.ID}}" title="{{item.Volume}}-{{item.Issue}}"
                      (click)="LoadVolIssueData(item.ID);">{{item.Volume}}-{{item.Issue}}</span>
              </div>
            </div>

            <div id="divIssueInfo" class="col-12">
              <div class="col-12" id="divRightPanel" [style.display]="modelItem.showIssueContentBody ? 'block' : 'none'">
                <div id="divHeaderContent" class="row">
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td>
                          <div id="divIssueSummary" style="white-space: nowrap; display: block;">
                            <div class="row">
                              <div class="col-6">
                                <table class="tblIssueSummary">
                                  <thead>
                                    <tr><th colspan="5" id="thCurrent">Current Issue (NA - NA)</th></tr>
                                    <tr>
                                      <th>Budgeted pages</th>
                                      <th>Number of Papers </th>
                                      <th>Pages allotted</th>
                                      <th>Sig.Count</th>
                                      <th>Month/Year</th>
                                    </tr>
                                  </thead>
                                  <tbody *ngIf="modelItem.IssueConfig !=null">
                                    <tr>
                                      <td><label class="control-label lblPPi">{{modelItem.IssueConfig.PagePerIssue}}</label></td>
                                      <td>
                                        <label class="control-label" id="lblNoOfPaper_Top" *ngIf="modelItem.ApprovedArticleList !=null">
                                          {{modelItem.ApprovedArticleList.length }}
                                        </label>

                                        <label class="control-label" id="lblNoOfPaper_Top" *ngIf="modelItem.ApprovedArticleList == null">
                                          0
                                        </label>
                                      </td>
                                      <td><label class="control-label" id="lblTotalPages_Top">{{modelItem.CurrentPagesAllotted}}</label></td>
                                      <td><label class="control-label" id="lblSigCnt">{{modelItem.IssueConfig.SignatureCount}}</label></td>
                                      <td><label class="control-label" id="lblIssueMonth">{{modelItem.IssueConfig.IssueMonth}}/{{modelItem.IssueConfig.IssueYear}}</label></td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div class="col-6">
                                <table class="tblIssueSummary">
                                  <thead>
                                    <tr><th colspan="5" id="thOverAll">Current Volume (NA)</th></tr>
                                    <tr>
                                      <th>Page Budget</th>
                                      <th>No.of issue</th>
                                      <th>Pages/issue</th>
                                      <th>Total Pages allotted</th>
                                      <th>Remaining pages</th>
                                    </tr>
                                  </thead>
                                  <tbody *ngIf="modelItem.IssueConfig !=null">
                                    <tr>
                                      <td><label class="control-label" id="lblTotalIssueCt">{{modelItem.IssueConfig.PagePerIssue * modelItem.IssueConfig.Issue}}</label></td>
                                      <td><label class="control-label" id="lblNoofIssue">{{modelItem.IssueConfig.Issue}}</label></td>
                                      <td><label class="control-label lblPPi" id="lblPPi">{{modelItem.IssueConfig.PagePerIssue}}</label></td>
                                      <td>
                                        <label class="control-label" id="lblTotAlloted">{{modelItem.IssueConfig.PageAlloted}}</label>
                                      </td>
                                      <td>
                                        <label class="control-label" id="lblRemaining">
                                          {{(modelItem.IssueConfig.PagePerIssue * modelItem.IssueConfig.Issue) - modelItem.IssueConfig.PageAlloted}}
                                        </label>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <br /> <hr /><br />
                <div id="divIssueElementList">
                  <form id="frmFiles">
                    <div id="divIssueMain" style="overflow: hidden; overflow-y: auto">
                      <div id="divWorkflowList" class="col">

                        <!--Stage Scheduler details-->
                        <div id="divStageTable">
                          <table id="tblTaskList" class="tblIssueSummary" width="100%">
                            <thead>
                              <tr>
                                <th>Stage</th>
                                <th>Planned Date</th>
                                <th>Revised Schedule</th>
                                <th>Completed Date</th>
                                <th class="tblActions" *ngIf="checkUpdateIssueClosure">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let item of modelItem.ProjectPlanList">
                                <td>{{item.Stage}}</td>
                                <td>
                                  {{item.PlannedDate}}
                                </td>
                                <td>{{item.RevisedDate}}</td>
                                <td>

                                  <span *ngIf="(item.ActivityDateModify) && (item.CompletedDate == null || item.CompletedDate == '')">
                                    <input type="date" class="form-control" name="CompletedDate" id="TxtCompletedDate{{item.ActivityId}}" />
                                  </span>
                                  <span *ngIf="item.CompletedDate != ''">
                                    {{item.CompletedDate}}
                                  </span>
                                </td>
                                <td class="tblActions" *ngIf="checkUpdateIssueClosure">
                                  <span *ngIf="item.CompletedDate !=''">
                                    <i class="fa fa-cloud-download-alt iIcon" title="Download Package"
                                       (click)="DownloadPackage(item.Actions,item.FlowId)" *ngIf="item.DownloadActionAfterComplete"></i>
                                    <i class="fa fa-retweet iIcon" title="Reopen Approval"
                                       (click)="ReopenIssue()" *ngIf="item.ApproveForRevised"></i>
                                    <span *ngIf="item.ArticleLink_iCodex">
                                      <a [href]="item.ArticleLink_iCodex" target="_blank">
                                        <i class="fa fa-link iIcon" title="Issue Link"></i>
                                      </a>
                                    </span>
                                  </span>

                                  <span *ngIf="item.CompletedDate =='' && (item.CurrentActivity) && (!item.FromSmart)">

                                    <i class="fa fa-cloud-download-alt iIcon" title="Download Package"
                                       (click)="DownloadPackage(item.Actions,item.FlowId)"
                                       *ngIf="(item.DownloadAction && item.DownloadActionAfterComplete)"></i>

                                    <i class="fa fa-edit iIcon" title="Correction" style="color:red"
                                       (click)="PCCorrection(item.Actions,item.TransID,item.DownloadAction,'Correction')" *ngIf="item.CorrectionAction"></i>

                                    <i class="fa fa-edit iIcon" title="Instruction Upload" style="color:green"
                                       (click)="PCCorrection(item.Actions,item.TransID,item.DownloadAction,'{{item.Stage}}_Upload')" *ngIf="item.UploadAction"></i>

                                    <i class="fa fa-check iIcon" title="Approval"
                                       (click)="PCApproval(item.Actions,item.TransID,item.DownloadAction,item.ApproveAttachment,item.BlockApproval)" *ngIf="item.ApproveAction"></i>
                                  </span>

                                  <span *ngIf="item.ActivityDateModify && (item.CompletedDate == null || item.CompletedDate == '')">
                                    <i class="fa fa-check-circle iIcon" title="Update Date" (click)="UpdateCompletedDate(item.ActivityId)"></i>
                                  </span>

                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <!--Article List Show After Issue Closure-->
                        <div *ngIf="modelItem.checkIssueClouse != 0">
                          <br /> <hr /><br />
                          <div class="col-sm-10">
                            <h5><strong>Article List</strong></h5>
                          </div>
                          <table id="tblClosedArticleList" class="tblIssueSummary" width="100%">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Article No</th>
                                <th *ngIf="checkIssueViewFormat1">Corres Author</th>
                                <th>DOI</th>
                                <th>Article Type</th>
                                <th>Pages</th>
                                <th *ngIf="checkIssueViewFormat1">Sequential Pages</th>
                                <th>MS Section</th>
                                <th>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr #trArticleList *ngFor="let item of modelItem.ApprovedArticleList;let i = index;let last = last;"
                                  class="tr{{item.RowClass}}" title="Article {{item.RowClass}}">
                                <td>{{i+1}}</td>
                                <td>
                                  <span class="spLink" title="{{item.ArticleNo}}" (click)="showArticleMetaAndInfo(item.ID)">
                                    {{item.ArticleNo}}
                                  </span>
                                </td>
                                <td *ngIf="checkIssueViewFormat1">{{item.Authors}}</td>
                                <td>{{item.DOI}}</td>
                                <td>{{item.ArticleType}}</td>
                                <td name="Pages" value="{{item.ProofPage}}">{{item.ProofPage}}</td>
                                <td *ngIf="checkIssueViewFormat1">{{item.StartPage}}-{{item.EndPage}}</td>
                                <td>{{item.SubSection}}</td>
                                <td>{{item.Status}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div id="divIssueClosureMainContent">

                          <div *ngIf="modelItem.checkIssueClouse == 0">
                            <!--Front Matter details-->
                            <div id="divFMTable" *ngIf="modelItem.FrontMatter">
                              <br /> <hr /><br />
                              <div class="row">
                                <div class="col-sm-10">
                                  <h5><strong>Front Elements</strong></h5>
                                </div>
                                <div class="col-sm-2 btnAddIcon" *ngIf="checkUpdateIssueClosure">
                                  <button type="button" class="btn btn-outline-info waves-effect waves-light" value="Add more articles Issue"
                                          (click)="AddElements('Front')">
                                    <i class="fas fa-plus-square" title="Add Front Elements"></i>
                                  </button>
                                  &nbsp;
                                  <button type="button" class="btn btn-outline-info waves-effect waves-light btnUploadIssueFiles" value="Save Issue Files"
                                          (click)="UploadIssueFiles()">
                                    <i class="fas fa-save" title="Upload Issue Files"></i>
                                  </button>

                                </div>
                              </div>
                              <table id="tblFrontMatterList" class="tblIssueSummary" width="100%">
                                <thead>
                                  <tr>
                                    <th>Elements</th>
                                    <th>Attachment</th>
                                    <th>Description</th>
                                    <th>Pages</th>
                                    <th *ngIf="checkIssueViewFormat1">Sequential Pages</th>
                                    <th class="tblActions" *ngIf="modelItem.FrontElementActions && checkUpdateIssueClosure">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let item of modelItem.FromMatterList">
                                    <td style="text-align:left">
                                      {{item.Elements}}
                                    </td>
                                    <td>
                                      <div *ngIf="item.Attachments ==''">
                                        <div id="fileName_{{item.ID}}" style="display:none">{{item.UploadFileName}}</div>
                                        <input type="file" name="fileupload" value="fileupload" id="fileFmFu_{{item.ID}}"
                                               accept="{{item.FileType}}" (change)="fileTypeChange($event)">
                                      </div>

                                      <div id="IcId_{{item.ClosureID}}" *ngIf="item.Attachments !=''" class="row spLink">
                                        <div class="col-8">
                                          <i title="Click to Download Upload Files" (click)="DownloadIssueFile(item.ClosureID)">
                                            {{item.Attachments}}
                                          </i>
                                        </div>
                                        <div class="col-2">
                                          <button type="button" class="btnRemoveIssueFile" (click)="RemoveIssueFile()"
                                                  style="display:none">
                                          </button>
                                          <i class="fa fa-times iIcon DelFront" style="float:right" title="Remove Issue File"
                                             (click)="RemoveIssueFileConfim(item.ClosureID)"></i>
                                        </div>
                                      </div>
                                    </td>
                                    <td><input type="text" id="txtDesFm_{{item.ID}}" name="FmDescription" /></td>
                                    <td>
                                      <input type="text" id="txtPagesFm_{{item.ID}}" name="FmPages" value="{{item.Pages}}"
                                             maxlength="3" (keypress)="numberOnly($event)" />
                                    </td>
                                    <td *ngIf="checkIssueViewFormat1">{{item.StartPage}}-{{item.EndPage}}</td>
                                    <td class="tblActions" *ngIf="modelItem.FrontElementActions && checkUpdateIssueClosure">
                                      <i class="fa fa-times iIcon DelFront" title="Remove Elements" (click)="RemoveElementsMatterRow('DelFront')"></i>
                                      &nbsp;&nbsp;
                                      <i class="fa fa-check iIcon" title="Mandatory Elements" style="display:none"></i>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>

                            <!--Article details-->
                            <div id="divArticleTable">
                              <br /> <hr /><br />

                              <div class="row d-flex justify-content-between align-items-center">

                                <!-- LEFT SIDE -->
                                <div class="col-sm-8 d-flex align-items-center">
                                  <h5><strong>Article List</strong></h5>
                                </div>

                                <!-- RIGHT SIDE -->
                                <div class="col-sm-4 d-flex justify-content-end align-items-center btnAddIcon" *ngIf="checkUpdateIssueClosure">

                                  <button type="button" class="btn btn-outline-info waves-effect waves-light" (click)="ShowDivider()" title="Add Divider"
                                          *ngIf="checkIssueViewFormat1">
                                    <i class="fas fa-grip-lines"></i>
                                  </button>

                                  <input type="number"
                                         id="TxtIssueStartPage"
                                         class="form-control mx-2"
                                         style="width: 80px;"
                                         [style.display]="checkIssueViewFormat1 ? 'inline-block' : 'none'"
                                         [value]="modelItem?.IssueConfig?.StartPageNo"
                                         min="0" />

                                  <button type="button" class="btn btn-outline-info waves-effect waves-light mx-1"
                                          (click)="ShowArticles()">
                                    <i class="fas fa-plus-square" title="Add Articles"></i>
                                  </button>

                                  <button type="button" class="btn btn-outline-info waves-effect waves-light btnSaveLineupOrder mx-1"
                                          (click)="SaveIssueLineupOrder()">
                                    <i class="fas fa-save" title="Save Article Display Order"></i>
                                  </button>

                                </div>

                              </div>


                              <!--<table #dataTableIssArticle class="display" style="width:100%"></table>-->
                              <div class="fixTableHead1" id="divIssueArticleList">
                                <table id="tblArticleList" class="tblIssueSummary" width="100%">
                                  <thead>
                                    <tr>
                                      <th>#</th>
                                      <th style="display:none">Id</th>
                                      <th>Article No</th>
                                      <th *ngIf="checkIssueViewFormat1">Corres Author</th>
                                      <th>DOI</th>
                                      <th>Article Type</th>
                                      <th>Pages</th>
                                      <th *ngIf="checkIssueViewFormat1">Sequential Pages</th>
                                      <th>MS Section</th>
                                      <th>Status</th>
                                      <th class="tblActions" *ngIf="checkUpdateIssueClosure">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr #trArticleList *ngFor="let item of modelItem.ApprovedArticleList;let i = index;let last = last;"
                                        class="tr{{item.RowClass}}" title="Article {{item.RowClass}}">
                                      <td>{{i+1}}</td>
                                      <td style="display:none">{{item.ID}}</td>
                                      <td>
                                        <span class="spLink" title="{{item.ArticleNo}}" (click)="showArticleMetaAndInfo(item.ID)">
                                          {{item.ArticleNo}}
                                        </span>
                                      </td>
                                      <td *ngIf="checkIssueViewFormat1">{{item.Authors}}</td>
                                      <td>{{item.DOI}}</td>
                                      <td>{{item.ArticleType}}</td>
                                      <td name="Pages" value="{{item.ProofPage}}">{{item.ProofPage}}</td>
                                      <td *ngIf="checkIssueViewFormat1">{{item.StartPage}}-{{item.EndPage}}</td>
                                      <td>{{item.SubSection}}</td>
                                      <td>{{item.Status}}</td>
                                      <td class="tblActions" *ngIf="checkUpdateIssueClosure">
                                        <i class="fa fa-times iIcon" title="Remove Article from Volume-Issue"
                                           (click)="RemoveArticleFrom(item.ID,item.Status === 'SectionPlacement')"></i>
                                        <span style="display:none">{{last ? callArticleLastRow(i) : ''}}</span>
                                      </td>
                                    </tr>
                                    <tr *ngIf="!modelItem.ApprovedArticleList || modelItem.ApprovedArticleList.length==0">
                                    </tr>
                                  </tbody>
                                </table>
                                <button type="button" title="Get" id="btnRemoveArticle" style="display:none" (click)="RevertIssue()">Get</button>
                              </div>
                            </div>

                            <!--Back Matter details-->
                            <div id="divBMTable" *ngIf="modelItem.BackMatter">
                              <br /> <hr /><br />
                              <div class="row">
                                <div class="col-sm-10">
                                  <h5><strong>Back Elements</strong></h5>
                                </div>
                                <div class="col-sm-2 btnAddIcon" *ngIf="checkUpdateIssueClosure">
                                  <button type="button" class="btn btn-outline-info waves-effect waves-light" value="Add more articles Issue"
                                          (click)="AddElements('Back')">
                                    <i class="fas fa-plus-square" title="Add Back Elements"></i>
                                  </button>
                                  &nbsp;
                                  <button type="button" class="btn btn-outline-info waves-effect waves-light btnUploadIssueFiles" value="Save Issue Files"
                                          (click)="UploadIssueFiles()">
                                    <i class="fas fa-save" title="Upload Issue Files"></i>
                                  </button>
                                </div>
                              </div>
                              <table id="tblBackMatterList" class="tblIssueSummary" width="100%">
                                <thead>
                                  <tr>
                                    <th>Elements</th>
                                    <th>Attachment</th>
                                    <th>Description</th>
                                    <th>Pages</th>
                                    <th *ngIf="checkIssueViewFormat1">Sequential Pages</th>
                                    <th class="tblActions" *ngIf="modelItem.BackElementActions && checkUpdateIssueClosure">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let item of modelItem.BackMatterList">
                                    <td>{{item.Elements}}</td>
                                    <td>

                                      <!--<input type="file" name="fileupload" value="fileupload'" id="fileBmFu_{{item.ID}}">-->
                                      <div *ngIf="item.Attachments ==''">
                                        <div id="fileName_{{item.ID}}" style="display:none">{{item.UploadFileName}}</div>
                                        <input type="file" name="fileupload" value="fileupload" id="fileBmFu_{{item.ID}}"
                                               accept="{{item.FileType}}" (change)="fileTypeChange($event)">
                                      </div>

                                      <div id="IcId_{{item.ClosureID}}" *ngIf="item.Attachments !=''" class="row spLink ">
                                        <div class="col-8">
                                          <i title="Click to Download Upload Files" (click)="DownloadIssueFile(item.ClosureID)">
                                            {{item.Attachments}}
                                          </i>
                                        </div>
                                        <div class="col-2">
                                          <button type="button" class="btnRemoveIssueFile" (click)="RemoveIssueFile()" style="display:none">
                                          </button>
                                          <i class="fa fa-times iIcon DelFront" style="float:right" title="Remove Issue File"
                                             (click)="RemoveIssueFileConfim(item.ClosureID)"></i>
                                        </div>
                                      </div>
                                    </td>
                                    <td><input type="text" id="txtDesBm_{{item.ID}}" name="BmDescription" /></td>
                                    <td>
                                      <input type="text" id="txtPagesBm_{{item.ID}}" name="BmPages"
                                             value="{{item.Pages}}" maxlength="3" (keypress)="numberOnly($event)" />
                                    </td>
                                    <td *ngIf="checkIssueViewFormat1">{{item.StartPage}}-{{item.EndPage}}</td>
                                    <td class="tblActions" *ngIf="modelItem.BackElementActions && checkUpdateIssueClosure">
                                      <i class="fa fa-times iIcon DelBack" title="Remove Elements" (click)="RemoveElementsMatterRow('DelBack')"></i>
                                      &nbsp;&nbsp;
                                      <i class="fa fa-check iIcon" title="Mandatory Elements" style="display:none"></i>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>

                          </div>

                          <br /> <hr /><br />
                          <div id="divIssueRemarks">
                            <div class="row">
                              <div class="col-sm-10">
                                <h5><strong>Issue Remarks</strong></h5>
                              </div>
                              <div class="col-sm-2 btnAddIcon" *ngIf="checkUpdateIssueClosure">

                                <button type="button" class="btn btn-outline-info waves-effect waves-light btnUploadIssueFiles" value="Save Issue Remarks"
                                        (click)="UpdateIssueRemarks()">
                                  <i class="fas fa-save" title="Upload Issue Files"></i>
                                </button>
                              </div>
                            </div>

                            <textarea id="TxtIssueRemarks" rows="10" class="col-12"></textarea>
                          </div>
                          <br /> <hr /><br />

                        </div>
                      </div>
                    </div>



                    <div class="modal-footer d-flex justify-content-between align-items-center">

                      <!-- LEFT -->
                      <div class="d-flex gap-2" *ngIf="checkIssueViewFormat1">

                        <button type="button"
                                class="btn btn-outline-info waves-effect waves-light"
                                (click)="IssueElementsCustomerApi()">
                          <i class="fa fa-check-circle"></i>
                          <span *ngIf="modelItem.checkIssueAPIComplete== 0"> Create Issue Scheduler</span>
                          <span *ngIf="modelItem.checkIssueAPIComplete!= 0"> Update Issue Scheduler</span>
                        </button>

                        <button type="button" class="btn btn-outline-info waves-effect waves-light"
                                (click)="IssueElementsCustomerApiComplete()" *ngIf="modelItem.checkIssueAPIComplete != 0">
                          <i class="fa fa-check-circle"></i>
                          <span> Complete Task</span>
                        </button>

                        <button type="button"
                                class="btn btn-outline-info waves-effect waves-light"
                                (click)="IssueAPIHistory()" *ngIf="modelItem.checkIssueAPIComplete != 0">
                          <i class="fa fa-check-circle"></i>
                          <span> API History</span>
                        </button>

                      </div>


                      <!-- RIGHT -->
                      <div class="d-flex gap-2">

                        <button type="button" class="btn btn-outline-info waves-effect waves-light"
                                (click)="DownloadTOCFile()" *ngIf="checkIssueViewFormat1">
                          <i class="fa fa-cloud-download-alt"></i>
                          <span>&nbsp; Download TOC</span>
                        </button>

                        <button type="button" value="Issue Closure" style="display:none" id="btnIssueCls" (click)="IssueClosure()"
                                *ngIf="modelItem.checkIssueClouse == 0 && checkUpdateIssueClosure">
                          <i class="fa fa-check-circle"></i>
                          Issue Closure
                        </button>

                        <button type="button"
                                class="btn btn-outline-info waves-effect waves-light"
                                (click)="IssueClosureConfirm()"
                                *ngIf="modelItem.checkIssueClouse == 0 && checkUpdateIssueClosure">
                          <i class="fa fa-check-circle"></i>
                          Issue Closure
                        </button>

                        <button type="button"
                                class="btn btn-outline-danger waves-effect waves-light"
                                id="btnBacktoList"
                                (click)="IssueViewAction('List')">
                          <i class="fa fa-arrow-left"></i>
                          Back
                        </button>
                      </div>

                    </div>



                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button type="button" id="btnApproveArtList" style="display:none" (click)="GetApproveArticleList()"></button>
        <div class="modal" id="myModal" [style.display]="modelItem.showAddArticle ? 'block' : 'none'">
          <div class="modal-dialog modal-xl custome-modal">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">UnAssigned Article List</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">&times;</button>
              </div>
              <div class="modal-body" id="divModelbody">
                <table #dataTable class="display" style="width:100%"></table>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                <button type="button" class="btn btn-outline-success waves-effect waves-light" value="Add" (click)="AddArticletoIssue()"> Add </button>
              </div>

              <div id="LoadingImagePopup">
                <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
              </div>
            </div>
          </div>
        </div>


        <div class="modal" id="myModalDivider" [style.display]="modelItem.showAddDivider ? 'block' : 'none'">
          <div class="modal-dialog custome-modal">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">Add Divider</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="HideDivider()">&times;</button>
              </div>

              <div class="modal-body">
                <form [formGroup]="dividerForm">
                  <!-- Section/Placement -->
                  <div class="form-group">
                    <label>Section/Placement</label>
                    <input type="text" class="form-control"
                           formControlName="sectionPlacement">
                    <small class="text-danger"
                           *ngIf="dividerForm.get('sectionPlacement')?.touched &&
                  dividerForm.get('sectionPlacement')?.hasError('required')">
                      Section/Placement is required
                    </small>
                  </div>

                  <!-- Content Type -->
                  <div class="form-group">
                    <label>Content Type</label>
                    <input type="text" class="form-control"
                           formControlName="contentType">
                    <small class="text-danger"
                           *ngIf="dividerForm.get('contentType')?.touched &&
                  dividerForm.get('contentType')?.hasError('required')">
                      Content Type is required
                    </small>
                  </div>

                  <!-- Pages -->
                  <div class="form-group">
                    <label>Pages</label>
                    <input type="number" class="form-control" min="0" formControlName="pages">
                  </div>

                  <!-- Description -->
                  <div class="form-group">
                    <label>Content Description</label>
                    <textarea class="form-control" rows="4"
                              formControlName="contentDescription"></textarea>
                    <small class="text-danger"
                           *ngIf="dividerForm.get('contentDescription')?.touched &&
                  dividerForm.get('contentDescription')?.hasError('required')">
                      Description is required
                    </small>
                  </div>
                </form>
              </div>


              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light"
                        data-dismiss="modal" (click)="HideDivider()">
                  Close
                </button>
                <button type="button" class="btn btn-outline-success waves-effect waves-light" value="Add"
                        (click)="AddDivider()">
                  Add
                </button>
              </div>

              <div id="LoadingImagePopup1">
                <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
              </div>
            </div>
          </div>
        </div>


        <app-articlemeta></app-articlemeta>

      </div>
    </div>
  </div>
</div>

<div id="myModal_Corrections" class="modal" role="dialog" [style.display]="showCorrectionModal ? 'block' : 'none'">
  <div class="modal-dialog modal-lg">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="Lblh4CorrTitle">Further Corrections</h4>
        <!--<button type="button" class="close" data-dismiss="modal">×</button>-->

      </div>
      <div class="modal-body" name="correctionPopup">
        <div class="col">
          <div class="form-group col-4" style="display:none">
            <label for="ddlCorrectionType">Type</label><br>
            <select id="ddlCorrectionType" class="form-control select2" style="width: 100%;">
              <option value="Correction" selected>Stage Correction</option>
              <option value="Upload">Stage Instruction</option>
            </select>
          </div>
          <div class="form-group col">
            <label for="TxtInstructionIssue">Instructions</label>
            <textarea class="form-control rounded-0" id="TxtIssueInstruction" rows="5"></textarea>
          </div>
          <div class="form-group col">
            <label for="FU_IssueAttchment" id="LblFileName">Correction File</label>
            <div class="custom-file">
              <input type="file" multiple="" id="FU_IssueAttchment" (change)="fileChangeEvent($event)">
            </div>
          </div>
          <div class="form-group row">
            <div class="form-group col-6 divHideCtrl" id="divCtrlUpload">
              <label for="Txt_IssueUploadPages">Pages</label>
              <input type="number" class="form-control float-right" min="0" max="1000" id="Txt_IssueUploadPages" value="0" />
            </div>
            <div class="form-group col-6">
              <label for="Txt_IssueDueDate">Due Date</label>
              <input type="date" class="form-control float-right" id="Txt_IssueDueDate" />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnPMCorrections" (click)="updateIssueCorrection()">{{popupCorrectionButtonText}}</button>
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideCorrectionModal()">Close</button>
      </div>
    </div>
    <div id="LoadingImagePopup1">
      <img src="assets/Images/loader.gif" class="imgLoadimg" alt="" />
    </div>
  </div>
</div>


<div id="myModal_ApproveCorrections" class="modal" role="dialog" [style.display]="showApprovalModal ? 'block' : 'none'">
  <div class="modal-dialog modal-lg">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="Lblh4AppCorrTitle">Approval Corrections</h4>

      </div>
      <div class="modal-body" name="ApprovalcorrectionPopup">
        <div class="col">
          <div class="form-group col">
            <label for="FU_IssueApproveAttchment">Aproval Correction File</label>
            <div class="custom-file">
              <input type="file" id="FU_IssueApproveAttchment" (change)="ApproveFileChangeEvent($event)">
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnPMApprove" (click)="updateApprovalCorrection()">{{popupApprovalButtonText}}</button>
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideAppCorrectionModal()">Close</button>
      </div>
    </div>
  </div>
</div>
<!--New Issue Add details-->
<div class="modal" id="myModalIssueAdd" [style.display]="showModal ? 'block' : 'none'">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{title}}</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="hideIssueAdd()">&times;</button>
      </div>
      <div class="modal-body">
        <form>
          <div class="row col">

            <div class="col-sm-6">
              <div class="form-group">
                <label>Journal</label><em>*</em>
                <select id="ddlJournals" class="form-control ddlselect">
                  <option value=0>Select</option>
                  <option *ngFor="let item of modelItem.JournalList" value={{item.ID}}>
                    {{item.Acronym}}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label>Issue Type</label><em>*</em>
                <select id="ddlIssueType" class="form-control ddlselect">
                  <option value=0>Select </option>
                  <option *ngFor="let item of modelItem.IssueTypeList" value={{item.Id}}>
                    {{item.IssueType}}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="form-group">
                <label>Year</label><em>*</em>
                <input class="form-control IsNumeric" type="text" min="4" maxlength="4" id="TxtIssueYear">
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label>Month</label><em>*</em>
                <select id="ddlIssueMonth" class="form-control ddlselect">
                  <option value=0 selected="selected">Select</option>
                  <option *ngFor="let item of monthNameList" value={{item}}>
                    {{item}}
                  </option>
                </select>
              </div>

            </div>
            <div class="col-sm-2">
              <div class="form-group">
                <label>Volume</label><em>*</em>
                <input class="form-control" type="text" maxlength="5" id="TxtVolume" autocomplete="off">
              </div>
            </div>

            <div class="col-sm-2">
              <div class="form-group">
                <label>Issue</label><em>*</em>
                <input class="form-control" type="text" maxlength="5" id="TxtIssue" autocomplete="off">
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label>Last Manuscript Entry</label><em>*</em>
                <input class="form-control" type="date" id="datelastmanuscript">
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label>Issue MakeUp</label><em>*</em>
                <input class="form-control" type="date" id="dateissuemakeup">
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label>New Cover Added</label>
                <select id="ddlNewCoverAdded" class="form-control ddlselect">
                  <option value="false" selected="selected">false</option>
                  <option value="true">true</option>
                </select>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label>Issue Title</label><em>*</em>
                <input class="form-control" type="text" id="TxtIssueTitle" autocomplete="off">
              </div>
            </div>
          </div>
        </form>
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideIssueAdd()">Close</button>
          <button type="submit" (click)="AddIssueDetails()" class="btn btn-outline-success waves-effect waves-light">{{popupButtonText}}</button>
          <!--<button type="button" class="btn btn-outline-success waves-effect waves-light" value="Add" (click)="AddIssueDetails()">Add</button>-->
        </div>

        <div id="LoadingImagePopup">
          <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
        </div>
      </div>
    </div>
  </div>

</div>


<div class="modal" id="myModalIssueSchedule" [style.display]="showIssueScheduleModal ? 'block' : 'none'">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Issue Schedule</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="hideIssueSchedule()">&times;</button>
      </div>
      <div class="modal-body">
        <form>
          <div style="max-height:450px; overflow:auto;">
            <table class="table table-bordered ">
              <thead style="background: #c2d1f9">
                <tr>
                  <th></th>
                  <th>Issue Group</th>
                  <th>Issue Task</th>
                  <th style="width:200px;">Resource</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let row of issueRows">

                  <!-- checkbox -->
                  <td>
                    <input type="checkbox"
                           [(ngModel)]="row.IsDefault || row.AddedInIssue"
                           name="chk{{row.Id}}"
                           [disabled]="row.IsDefault === 1">
                  </td>

                  <!-- group -->
                  <td>{{ row.TaskGroup }}</td>

                  <!-- task -->
                  <td>{{ row.IssueTask }}</td>

                  <!-- resource -->
                  <td>
                    <select class="form-control"
                            [(ngModel)]="row.JournalColumnValue"
                            name="res{{row.Id}}">
                      <option [ngValue]="null">null</option>
                      <option *ngFor="let r of resources" [ngValue]="r">
                        {{ r }}
                      </option>
                    </select>
                  </td>

                </tr>
              </tbody>
            </table>
          </div>
        </form>
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-danger waves-effect waves-light"
                  data-dismiss="modal" (click)="hideIssueSchedule()">
            Close
          </button>
          <button type="submit" (click)="AddIssueSchedule()"
                  class="btn btn-outline-success waves-effect waves-light">
            <span *ngIf="modelItem.checkIssueAPIComplete == 0">Create Schedule</span>
            <span *ngIf="modelItem.checkIssueAPIComplete != 0">Update Schedule</span>

          </button>

        </div>

        <div id="LoadingImagePopup">
          <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
        </div>
      </div>
    </div>
  </div>

</div>


<div class="modal" id="myModalIssueCompleteTask" [style.display]="showIssueCompleteModal ? 'block' : 'none'">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Issue CompleteTask</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="hideIssuecomplete()">&times;</button>
      </div>
      <div class="modal-body">
        <form>
          <div style="max-height:450px; overflow:auto;">
            <table class="table table-bordered ">
              <thead style="background: #c2d1f9">
                <tr>
                  <th>Issue Group</th>
                  <th>Issue Task</th>
                  <th style="width:200px;">Resource</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let row of issueCRows">
                  <!-- group -->
                  <td>{{ row.TaskGroup }}</td>

                  <!-- task -->
                  <td>{{ row.IssueTask }}</td>

                  <!-- resource -->
                  <td>
                    <select class="form-control"
                            [(ngModel)]="row.JournalColumnValue"
                            name="res{{row.Id}}">
                      <option [ngValue]="null">null</option>
                      <option *ngFor="let r of resources" [ngValue]="r">
                        {{ r }}
                      </option>
                    </select>
                  </td>
                  <td>
                    <input type="checkbox"
                           [(ngModel)]="row.AddedInIssue"
                           name="chk{{row.Id}}"
                           [disabled]="row.CompletedDate != null">
                  </td>

                </tr>
              </tbody>
            </table>
          </div>
        </form>
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-danger waves-effect waves-light"
                  data-dismiss="modal" (click)="hideIssuecomplete()">
            Close
          </button>
          <button type="submit" (click)="CompleteIssueTask()"
                  class="btn btn-outline-success waves-effect waves-light">
            <span *ngIf="modelItem.checkIssueAPIComplete != 0">Complete Task</span>
          </button>

        </div>

        <div id="LoadingImagePopup">
          <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal" id="myModalIssueHistory" [style.display]="showIssueHistoryModal ? 'block' : 'none'">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Issue Schedule</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="hideIssueHistory()">&times;</button>
      </div>

      <div class="modal-body">
        <form>
          <div style="max-height:450px; overflow:auto;">
            <table class="table table-bordered ">
              <thead style="background: #c2d1f9">
                <tr>
                  <th>API Name</th>
                  <th>Status</th>
                  <th>Resoonse Message</th>
                  <th>Update Time</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of issueHRows">
                  <td>{{ row.ApiName }}</td>
                  <td>{{ row.Status}}</td>
                  <td>{{ row.Message }}</td>
                  <td>{{ row.UpdatedTime }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </form>
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-danger waves-effect waves-light"
                  data-dismiss="modal" (click)="hideIssueHistory()">
            Close
          </button>
        </div>

        <div id="LoadingImagePopup">
          <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
        </div>

      </div>

    </div>

  </div>
</div>
